export const LABELS = {
  DOLLAR_HEADER: 'Your stock gift form has been sent to your broker',
  WHAT_IS_NEXT: 'What’s next?',
  INSTRUCTIONS_1: ['You’ll receive an email with your tax receipt', ' once your donation is complete'],
  DOLLAR_HEADER_OTHER: ['Form has been sent to your email address!', ' Please download, sign & send to your broker.'],
};

export default LABELS;
